import type { ReactElement } from 'react';

import type { TSocialMediaLink } from '@audacy-clients/core/atoms/wrappers/types';
import Icon from '~/components/Icon';
import { Icons } from '~/components/Icon/constants';

import { SocialMediaPlatform } from '@audacy-clients/data/src/constants/enums';
import styles from '../styles';

export type TContactSheetSocialMediaLinksProps = {
  socialMediaLinks: Array<TSocialMediaLink>;
};

function getSocialMediaIconName(platform: string): Icons | null {
  switch (platform) {
    case SocialMediaPlatform.FACEBOOK:
      return Icons.Facebook;
    case SocialMediaPlatform.INSTAGRAM:
      return Icons.Instagram;
    case SocialMediaPlatform.TWITTER:
      return Icons.XLogo;
    case SocialMediaPlatform.YOUTUBE:
      return Icons.YouTube;
    default:
      return null;
  }
}

function getSocialMediaIcon(url: string, socialMediaIconName: Icons): ReactElement {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      css={styles.socialMediaLinkClickableIcon}
    >
      <Icon iconColor="black" sizeInPx={26} name={socialMediaIconName} />
    </a>
  );
}

const ContactSheetSocialMediaLinks = ({
  socialMediaLinks,
}: TContactSheetSocialMediaLinksProps): ReactElement => {
  const socialMediaIcons: Array<ReactElement> = [];
  // only add icons if we have a name for them, otherwise they'll "render" as emptyspace
  for (const socialMediaLink of socialMediaLinks) {
    const socialMediaIconName = getSocialMediaIconName(socialMediaLink.platform);
    if (socialMediaIconName) {
      socialMediaIcons.push(getSocialMediaIcon(socialMediaLink.url, socialMediaIconName));
    }
  }

  return <div css={styles.socialMediaLinksContainer}>{socialMediaIcons}</div>;
};

export default ContactSheetSocialMediaLinks;
